module.exports = __webpack_public_path__ + "img/ceo_way_tip_03.b57a55a5.png";